import React from 'react';
import { Link } from 'react-router-dom';

const Inspiration = () => {
  const inspirationTools = [
    {
      id: 'color-palette',
      name: '手链配色灵感库',
      description: '提供多种手链配色方案，激发设计灵感',
      icon: '🎨',
      path: '/inspiration/color-palette'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-teal-50 py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold text-center mb-8 text-blue-800">
          灵感库
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {inspirationTools.map((tool) => (
            <Link
              key={tool.id}
              to={tool.path}
              className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300 border border-blue-100"
            >
              <div className="text-4xl mb-4">{tool.icon}</div>
              <h2 className="text-xl font-semibold mb-2 text-blue-700">
                {tool.name}
              </h2>
              <p className="text-gray-600">{tool.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Inspiration;